import { connect } from 'react-redux';

import { getCurrentLanguage, isRtl } from 'modules/language/selectors/language';
import IntlProvider from './IntlProvider';

export default connect(
  () => ({
    locale: getCurrentLanguage(),
    rtl: isRtl(),
  }),
)(IntlProvider);
